




import VueOptions from '@utils/VueOptions'
import OmnichannelSpaceEditWizard from '@ui/SpaceWizards/OmnichannelSpaceWizard/OmnichannelSpaceEditWizard'

settings =
  name: 'OmnichannelSpaceEdit'
  components: { OmnichannelSpaceEditWizard }

  vue:
    computed:
      optionsForWizard: ->
        supplierId: @supplierId

      supplierId: -> @$route.query?.supplierId

export default VueOptions.vue settings
